module.exports = __webpack_public_path__ + "img/20.c3c8aada.jpg";